import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Tooltip from 'material-ui/Tooltip';
import Input from 'material-ui/Input';

const inputStyles = () => ({
  inputRoot: {
    marginTop: '18px',
    width: '100%',
  },

  header: {
    fontSize: '13px',
    fontWeight: 'bold',
    padding: '8px 0px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '16px',
  },

  tooltip: {
    backgroundColor: '#d32f2f',
    maxWidth: '335px',
  },
});

const InputComponent = ({ classes, error, title, value, placeholder, onChange, ...other }) => (
  <div className={classes.inputRoot}>
    <div className={classes.header}>{title}</div>
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      placement="top-end"
      title={error}
    >
      <Input
        value={value}
        disableUnderline={true}
        placeholder={placeholder}
        onChange={onChange}
        error={!!error}
        fullWidth
        {...other}
      />
    </Tooltip>
  </div>
)

InputComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(inputStyles)(InputComponent)



// WEBPACK FOOTER //
// ./src/components/common/InputComponent.jsx